export default () => {

    if ($('.related-articles-swiper').length > 0) {
        const moments = new Swiper('.related-articles-swiper', {
            slidesPerView: 4,
            spaceBetween: 40,
            grabCursor: true,
            simulateTouch: true,
            preventClicks: true,
            keyboardControl: true,
            paginationClickable: true,
            navigation: {
                nextEl: '.next-article',
                prevEl: '.prev-article',
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    grid: {
                        rows: 2,
                    },
                    spaceBetween: 16,
                    pagination: {
                        el: '.swiper-pagination-2-mobile',
                        clickable: true,
                    },
                },
                600: {
                    slidesPerView: 2,
                    spaceBetween: 40,
                    slidesPerGroup: 2,
                    pagination: {
                        el: '.swiper-pagination-2',
                        clickable: true,
                    },
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                    slidesPerGroup: 3,
                    pagination: {
                        el: '.swiper-pagination-2',
                        clickable: true,
                    },
                },
                2048: {
                    slidesPerView: 4,
                    spaceBetween: 40,
                    slidesPerGroup: 4,
                    pagination: {
                        el: '.swiper-pagination-2',
                        clickable: true,
                    },
                },
            },
        });
    }

};
